export const MAX_BINDING_PARAMS = 65533;
